export default __webpack_public_path__ + "static/media/取消料について.d8de105f.pdf";